/**
 * Module dependencies.
 */

import { Choice, Step, StepKey } from 'src/types/advisor';
import {
  Context,
  Dispatch,
  SetStateAction,
  createContext,
  useContext
} from 'react';

import { ModelRangeProps } from 'src/types/model-ranges';

/**
 * Export `Filter` type.
 */

export type Filter = {
  [key: string]:
    | string
    | {
        from: string;
        to: string;
      };
};

/**
 * Export `LastAction` type.
 */

export type LastAction = 'initial' | 'next' | 'previous';

/**
 * `Props` type.
 */

type Props = {
  choices: Choice[];
  currentStep: Step | null;
  filteredModelRanges: ModelRangeProps[];
  filters: Filter[];
  getCheckedValue: (stepKey: StepKey, value?: string) => string | null;
  initialModelRanges: ModelRangeProps[];
  isLoadingModelRanges: boolean;
  isSuccessModelRanges: boolean;
  lastAction: LastAction;
  onGoToNext: (value: string, pageKey: StepKey, currentIndex: number) => void;
  onGoToPrevious: (currentIndex: number) => void;
  onGoToStep: (currentIndex: number) => void;
  onSetCurrentStep: Dispatch<SetStateAction<Step | null>>;
  onSetFilter: (key: string, value: string) => void;
  refetch: () => void;
  steps: { [key: string]: Step };
  visibleStep: number;
};

/**
 * Export `AdvisorContext` context.
 */

export const AdvisorContext: Context<Props> = createContext({} as Props);

/**
 * Export `useAdvisor` hook.
 */

export const useAdvisor = () => useContext(AdvisorContext);
